import { enUS } from 'date-fns/locale';

/**
 * Custom locale configuration for date pickers that starts the week on Monday.
 */
export const datePickerLocale = {
  ...enUS,
  options: {
    ...enUS.options,
    weekStartsOn: 1 as const, // Monday = 1, Sunday = 0
  },
};
